export const GoalTypes = {
    CONTRACT: "contract",
    ERP: "ERP"
}